import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';
import { ContextService } from 'src/core/services/context.service';
import { StatusTexts } from "src/app/shared/status-texts";

export class PaymentListDataService extends DataService<typeof Model.Accounting.Logic.ViewModels.PaymentSummary, Model.Accounting.Logic.ViewModels.PaymentSummary, PaymentSummary> {
	protected map(entity: Model.Accounting.Logic.ViewModels.PaymentSummary): PaymentSummary {
		return new PaymentSummaryModel(entity);
	}

	static make(context?: ContextService): PaymentListDataService {
		return new PaymentListDataService(context, ctx => ctx.PaymentSummaries);
	}
}

export class PaymentSummaryModel extends EntityModel<Model.Accounting.Logic.ViewModels.PaymentSummary, PaymentSummary> implements PaymentSummary {
	@property<PaymentSummaryModel>(o => o.entity.id, (e, value) => e.entity.id = value)
	public id: number;

	@property<PaymentSummaryModel>(o => o.entity.transactionId, (e, value) => e.entity.transactionId = value)
	public transactionId: string;

	@property<PaymentSummaryModel>(o => o.entity.serviceName, (e, value) => e.entity.serviceName = value)
	public serviceName: string;

	@property<PaymentSummaryModel>(o => o.entity.method, (e, value) => e.entity.method = value)
	public method: number;

	get methodText(): string {
		switch (this.method) {
			case 0:
				return 'Cash';
			case 1:
				return 'BankTransfer';
			case 2:
				return 'Card';
		}

		return '';
	}

	@property<PaymentSummaryModel>(o => o.entity.type, (e, value) => e.entity.type = value)
	public type?: number;

	get typeText(): string {
		switch (this.type) {
			case 0:
				return 'Payment';
			case 1:
				return 'Refund';
			case 2:
				return 'Deferred';
			case 4:
				return 'Cancelled';
		}

		return '';
	}

	@property<PaymentSummaryModel>(o => o.entity.status, (e, value) => e.entity.status = value)
	public status: number;

	get statusText(): string {
		return StatusTexts.getPaymentStatusFromNumber(this.status);
	}

	@property<PaymentSummaryModel>(o => o.entity.accountingTarget, (e, value) => e.entity.accountingTarget = value)
	public accountingTarget: number;

	get accountingTargetText(): string {
		let models = [];

		if (this.accountingTarget & 1) {
			models.push('Client');
		}
		if (this.accountingTarget & 2) {
			models.push('Agent');
		}
		if (this.accountingTarget & 4) {
			models.push('Supplier');
		}

		return models.join(', ');
	}

	@property<PaymentSummaryModel>(o => o.entity.paymentNumber, (e, value) => e.entity.paymentNumber = value)
	public paymentNumber: string;

	@property<PaymentSummaryModel>(o => o.entity.paymentReference, (e, value) => e.entity.paymentReference = value)
	public paymentReference: string;

	@property<PaymentSummaryModel>(o => o.entity.paymentDate, (e, value) => e.entity.paymentDate = value)
	public paymentDate: Date;

	@property<PaymentSummaryModel>(o => o.entity.currencyId, (e, value) => e.entity.currencyId = value)
	public currencyId: number;
	@property<PaymentSummaryModel>(o => o.entity.currencyFormat, (e, value) => e.entity.currencyFormat = value)
	public currencyFormat: string;
	@property<PaymentSummaryModel>(o => o.entity.currencyIsoCode, (e, value) => e.entity.currencyIsoCode = value)
	public currencyIsoCode: string;

	@property<PaymentSummaryModel>(o => parseFloat(o.entity.currencyRate.toString()), (e, value) => e.entity.currencyRate = value)
	public currencyRate: number;

	@property<PaymentSummaryModel>(o => parseFloat(o.entity.amount.toString()), (e, value) => e.entity.amount = value)
	public amount: number;
	
	public get sourceAmount(): number {
		return this.amount / this.currencyRate;
	}

	@property<PaymentSummaryModel>(o => o.entity.description, (e, value) => e.entity.description = value)
	public description: string;

	@property<PaymentSummaryModel>(o => o.entity.clientId, (e, value) => e.entity.clientId = value)
	public clientId?: number;
	@property<PaymentSummaryModel>(o => o.entity.clientDisplayName, (e, value) => e.entity.clientDisplayName = value)
	public clientDisplayName: string;

	@property<PaymentSummaryModel>(o => o.entity.agentId, (e, value) => e.entity.agentId = value)
	public agentId?: number;
	@property<PaymentSummaryModel>(o => o.entity.agentName, (e, value) => e.entity.agentName = value)
	public agentName: string;

	@property<PaymentSummaryModel>(o => o.entity.supplierId, (e, value) => e.entity.supplierId = value)
	public supplierId?: number;
	@property<PaymentSummaryModel>(o => o.entity.supplierTitle, (e, value) => e.entity.supplierTitle = value)
	public supplierTitle?: string;

	@property<PaymentSummaryModel>(o => o.entity.quoteId, (e, value) => e.entity.quoteId = value)
	public quoteId?: number;
	@property<PaymentSummaryModel>(o => o.entity.quote, (e, value) => e.entity.quote = value)
	public quote: any;
}



// WEBPACK FOOTER //
// ./src/app/accounting/shared/payments/list/payment-list.data.ts